<template>
  <div>
    <v-autocomplete
      v-model="selectedData"
      :items="items"
      :loading="isLoading"
      :search-input.sync="search"
      :multiple="multiple"
      :label="label"
      :prepend-inner-icon="prependInnerIcon"
      :error-messages="errorMessages"
      :disabled="disabled"
      :clearable="clearable && !readonly"
      :readonly="!!readonly"
      hide-selected
      hide-no-data
      item-text="name"
      item-value="id"
      @blur="$emit('blur')"
    >
      <template slot="selection" slot-scope="data">
        <v-chip
          :input-value="data.selected"
          :close="(clearable || (!clearable && !multiple)) && !readonly"
          @click:close="remove(data.item)"
        >
          <v-avatar left>
            <v-img :src="data.item.picture" cover></v-img>
          </v-avatar>
          {{ data.item.name }}
        </v-chip>
      </template>
      <template slot="item" slot-scope="{ item }">
        <v-list-item-avatar>
          <v-avatar size="30">
            <v-img :src="item.picture" cover></v-img>
          </v-avatar>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>
            {{ item.name }}
          </v-list-item-title>
          <v-list-item-subtitle
            v-if="item.division"
            v-text="item.division"
          ></v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </v-autocomplete>
  </div>
</template>
<script>
import userApi from "@/api/user/index";
export default {
  props: {
    value: {
      type: [Number, String, Array, Object],
      required: false,
      default() {
        return null;
      }
    },
    userObject: {
      type: [Object, Array],
      required: false,
      default() {
        return {};
      }
    },
    params: {
      type: [Object, Array],
      required: false,
      default() {
        return {};
      }
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    errors: {
      type: [String, Array],
      default() {
        return [];
      }
    },
    errorMessages: {
      type: [String, Array],
      default() {
        return [];
      }
    },
    label: {
      type: String,
      default: "Select Employee"
    },
    prependInnerIcon: {
      type: String,
      default: "icon-user-add"
    },
    itemsToExclude: {
      type: [Array, Number],
      default: null
    },
    clearable: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    truncate: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      isLoading: false,
      items: [],
      allUsers: [],
      selectedData: null,
      search: null,
      orgSlug: this.$route.params.slug
    };
  },
  watch: {
    value: {
      handler(newVal, oldVal) {
        if (!newVal && oldVal) {
          this.selectedData = "";
          this.populateInitialUsers();
        }
        if (!oldVal && newVal) {
          this.populateInitialUsers();
        }
      },
      immediate: true
    },
    search(val) {
      if (!val || this.items.length > 0) return;
      this.fetchUsers();
    },
    selectedData(val) {
      this.search = "";
      this.syncUserData(val);
      this.$emit("input", val);
    },
    itemsToExclude() {
      this.items = this.excludeRecord(this.allUsers);
    },
    params: {
      handler(oldVal, newVal) {
        if (JSON.stringify(newVal) === JSON.stringify(oldVal)) return;
        this.fetchUsers();
      }
    }
  },
  methods: {
    populateInitialUsers() {
      this.fetchUsers(this.value);
      if (Array.isArray(this.value)) {
        if (typeof this.value[0] === "object") {
          this.selectedData = this.value.map(user => user.user.id);
        } else {
          this.selectedData = this.value;
        }
      } else if (this.value === null) {
        this.selectedData = "";
      } else if (typeof this.value === "object") {
        this.selectedData = this.value.id;
      } else {
        this.selectedData = this.value;
      }
      this.$emit("input", this.selectedData);
    },
    remove(item) {
      if (this.selectedData instanceof Object) {
        const index = this.selectedData.indexOf(item.id);
        if (index >= 0) this.selectedData.splice(index, 1);
        this.$emit("remove", item);
      } else {
        this.selectedData = null;
      }
    },
    fetchUsers(initialData) {
      if (this.isLoading) return;
      this.isLoading = true;
      this.$axios
        .$get(userApi.autocomplete, { params: this.params })
        .then(response => {
          this.allUsers = response;
          if (this.itemsToExclude) {
            response = this.excludeRecord(response);
          }
          this.items = response.results;
          if (initialData) {
            this.syncUserData(initialData);
          }
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => (this.isLoading = false));
    },
    syncUserData(val) {
      if (val instanceof Array) {
        const userData = [];
        val.forEach(userID => {
          userData.unshift(this.items.find(user => user.id === userID));
        });
        this.$emit("update:userObject", userData);
      } else {
        const userData = this.items.find(user => user.id === val);
        this.$emit("update:userObject", userData);
      }
    },
    // Excludes the selected records from the list if value exists in prop itemsToExclude
    excludeRecord(response) {
      let excludedItem = [];
      if (typeof this.itemsToExclude === "number") {
        excludedItem.push(this.itemsToExclude);
      } else {
        excludedItem = this.itemsToExclude;
      }
      return response.filter(item => {
        return !excludedItem.includes(item.id);
      });
    }
  }
};
</script>
